import { motion } from "motion/react";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { DT } from "./DeltaTypography";

export function BackButton() {
  const navigate = useNavigate();
  return (
    <motion.div
      initial={{ opacity: 0, x: -40 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6, ease: "easeOut", delay: 0.3 }}
      style={{ position: "fixed", left: 0, top: "50%", transform: "translateY(-50%)", zIndex: 50, display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <motion.div
        animate={{ height: [24, 40, 24], opacity: [0.3, 0.7, 0.3] }}
        transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut" }}
        style={{ width: 1, background: "linear-gradient(180deg, transparent, rgba(107,0,21,0.8))", marginBottom: 6 }}
      />
      <motion.button
        data-testid="back-button"
        onClick={() => navigate(-1)}
        whileHover={{ x: 4, boxShadow: "4px 0 30px rgba(107,0,21,0.8), 8px 0 60px rgba(80,0,10,0.5), inset 0 0 20px rgba(107,0,21,0.2)" }}
        whileTap={{ scale: 0.94, x: 0 }}
        animate={{ boxShadow: ["2px 0 14px rgba(107,0,21,0.35), inset 0 0 8px rgba(107,0,21,0.08)", "2px 0 26px rgba(107,0,21,0.65), inset 0 0 16px rgba(107,0,21,0.15)", "2px 0 14px rgba(107,0,21,0.35), inset 0 0 8px rgba(107,0,21,0.08)"] }}
        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        style={{ cursor: "pointer", background: "linear-gradient(90deg, rgba(107,0,21,0.92) 0%, rgba(40,0,6,0.96) 100%)", border: "1px solid rgba(107,0,21,0.7)", borderLeft: "none", borderRadius: "0 6px 6px 0", padding: "14px 10px 14px 6px", display: "flex", flexDirection: "column", alignItems: "center", gap: 10, outline: "none" }}
      >
        <motion.span
          animate={{ filter: ["drop-shadow(0 0 3px rgba(255,255,255,0.5))", "drop-shadow(0 0 9px rgba(255,255,255,0.95)) drop-shadow(0 0 20px rgba(168,16,48,0.6))", "drop-shadow(0 0 3px rgba(255,255,255,0.5))"], x: [0, -2, 0] }}
          transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
          style={{ display: "flex", color: "rgba(255,255,255,0.95)" }}
        >
          <ChevronLeft size={16} strokeWidth={2.5} />
        </motion.span>
        {["A", "T", "R", "Á", "S"].map((letra, i) => (
          <motion.span key={i} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.4 + i * 0.06 }}
            style={{ fontFamily: DT.terminal, fontSize: "9px", color: "rgba(255,255,255,0.75)", letterSpacing: "0.05em", lineHeight: 1, textShadow: "0 0 8px rgba(255,255,255,0.45), 0 0 18px rgba(107,0,21,0.4)", writingMode: "vertical-rl", display: "block" }}>
            {letra}
          </motion.span>
        ))}
        <div style={{ width: "100%", height: 1, background: "linear-gradient(90deg, rgba(107,0,21,0.3), rgba(200,120,20,0.5))", boxShadow: "0 0 4px rgba(200,120,20,0.3)" }} />
        <motion.span
          animate={{ color: ["rgba(200,120,20,0.5)", "rgba(255,160,40,0.9)", "rgba(200,120,20,0.5)"], textShadow: ["0 0 4px rgba(200,120,20,0.3)", "0 0 12px rgba(255,160,40,0.7), 0 0 28px rgba(200,120,20,0.4)", "0 0 4px rgba(200,120,20,0.3)"] }}
          transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut" }}
          style={{ fontFamily: DT.terminal, fontSize: "11px", display: "block" }}>
          &#x2B21;
        </motion.span>
      </motion.button>
      <motion.div
        animate={{ height: [24, 40, 24], opacity: [0.3, 0.7, 0.3] }}
        transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut", delay: 1.75 }}
        style={{ width: 1, background: "linear-gradient(180deg, rgba(107,0,21,0.8), transparent)", marginTop: 6 }}
      />
    </motion.div>
  );
}
